// ============================================
// ギャラリー画像の入れ替え(GSAP Flip)
// サブ画像クリックでメイン画像とシームレスに入れ替える
// ============================================
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(Flip, CustomEase);

// 出だしは吸い付くように、中間で素早く交差し、最後は長くふわっと着地するカーブ
// (easeInOutQuint 相当: cubic-bezier(0.83, 0, 0.17, 1))
const gallerySwapEase = CustomEase.create('gallerySwap', '0.83, 0, 0.17, 1');

function galleryFlip() {
  const galleries = document.querySelectorAll('.js-gallery');
  if (!galleries.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  galleries.forEach((gallery) => {
    const main = gallery.querySelector('.js-gallery-main');
    const thumbs = gallery.querySelectorAll('.js-gallery-thumb');
    if (!main || !thumbs.length) return;

    // 連打でアニメーションが重ならないようにする
    let isAnimating = false;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (isAnimating) return;

        const thumbImg = thumb.querySelector('img');
        const mainImg = main.querySelector('img');
        if (!thumbImg || !mainImg) return;

        // 「視差効果を減らす」設定のユーザーにはアニメーションなしで入れ替える
        if (prefersReducedMotion.matches) {
          main.appendChild(thumbImg);
          thumb.appendChild(mainImg);
          return;
        }

        // FLIP: 入れ替え前の位置・サイズを記録 → DOM を入れ替え → 差分から補間
        const state = Flip.getState([mainImg, thumbImg]);
        main.appendChild(thumbImg);
        thumb.appendChild(mainImg);

        isAnimating = true;
        Flip.from(state, {
          duration: 1.05,
          ease: gallerySwapEase,
          // width/height ではなく transform(scale)で動かして GPU 合成だけで完結させる
          scale: true,
          absolute: true,
          zIndex: 10,
          // 2枚をわずかにずらして動かし、交差を有機的に見せる
          stagger: 0.06,
          onComplete: () => {
            isAnimating = false;
          },
        });
      });
    });
  });
}

export { galleryFlip };
